import { isNone } from '@ember/utils';

export default function isNotNone(value: any) {
  return !isNone(value);
}
